export type Province = {
	id: number;
	name: string;
	initials: string;
};

const API_KEY = process.env.REACT_APP_API_KEY || '';

const useProvinces = () => {
	const fetchProvinces = async () => {
		const storageKey = 'provinces';

		const cachedProvinces = localStorage.getItem(storageKey);
		if (cachedProvinces) {
			return JSON.parse(cachedProvinces) as Province[];
		}

		const response = await fetch(
			`${process.env.REACT_APP_GEOLOCATION_API_URL}/provinces`,
			{
				headers: {
					"x-api-key": API_KEY,
				},
			},
		);

		if (!response.ok) throw new Error('Erro ao buscar estados');

		const data = await response.json();

		const formattedProvinces = data.map((province: any) => ({
			id: province.id,
			name: province.name,
			initials: province.initials,
		}));

		localStorage.setItem(storageKey, JSON.stringify(formattedProvinces));
		return formattedProvinces;
	};

	return { fetchProvinces };
};

export default useProvinces;